"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "clientAccountKey": "ca_e57f2ba6d7f24aa1800dd40ac3565cf2",
    "name": "Mock ClientAccount",
    "type": "Individual",
    "status": "Pending",
    "contacts": [
        {
            "contact": {
                "contactKey": "con_043fbc767f6a411b96c58e08592d06d6",
                "fullName": "Mock Contact",
                "ownedByAfslKey": "afsl_14e4ab3c663849119f7ce91f5569672f",
                "attachedToClientAccounts": [
                    "ca_e57f2ba6d7f24aa1800dd40ac3565cf2"
                ],
                "emailAddresses": [
                    {
                        "emailType": "Work",
                        "emailAddress": "mock@mockdata.com",
                        "isPreferred": true
                    }
                ]
            },
            "isPrimary": true,
            "roles": [
                "Adviser"
            ]
        }
    ],
    "adviser": {
        "adviserKey": "adv_6436928bb49f4c41b17e5de0c8158539",
        "name": "Mock AdviserName",
        "workPhoneNumber": "+61-455-504-118",
        "mobilePhoneNumber": null,
        "emailAddress": "adviser@dummy.com",
        "calendarUrl": "https://calendar.adviser.dummy.com",
        "practice": {
            "practiceKey": "pra_5e93e5ba2b064176be84419c6cf5e3c8",
            "name": "Bullseye Wealth Management",
            "logoUrl": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/publicapi/logos/D41D8CD98F00B204E9800998ECF8427E.PNG?X-Amz-Expires=3600&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T052237Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e1c2571f3be52b5d2f26a9fd779e0bf83381dab5815891b6d8b2042a4f43705b"
        },
        "afsl": {
            "afslKey": "afsl_db7bdebfa6ad41679b8e352256c2edd9",
            "name": "Bullseye Wealth Management",
            "logoUrl": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/publicapi/logos/D41D8CD98F00B204E9800998ECF8427E.PNG?X-Amz-Expires=3600&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T052237Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e1c2571f3be52b5d2f26a9fd779e0bf83381dab5815891b6d8b2042a4f43705b"
        }
    },
    "inceptionDate": "2021-10-05T00:00:00",
    "currentValue": 2863715.34,
    "totalReturnValue": -224871.610000,
    "portfolios": [
        {
            "portfolioKey": "prt_9431687b9b2044aea20463de3980260e",
            "name": "Mock Test Portfolio 1",
            "clientAccountKey": "ca_e57f2ba6d7f24aa1800dd40ac3565cf2",
            "clientAccountName": "Mock ClientAccount",
            "serviceType": "StatementOfAdvice",
            "currentValue": 2863715.34,
            "totalReturnValue": -224871.610000,
            "totalReturnPercentage": -0.070951,
            "inceptionDate": "2020-12-31T00:00:00"
        }
    ],
    "valueOverTime": [
        {
            "date": "2021-01-01T00:00:00",
            "value": 95771.30
        },
        {
            "date": "2021-01-02T00:00:00",
            "value": 95771.30
        },
        {
            "date": "2021-01-03T00:00:00",
            "value": 95771.30
        },
        {
            "date": "2021-01-04T00:00:00",
            "value": 97205.76
        },
        {
            "date": "2021-01-05T00:00:00",
            "value": 96910.43
        },
        {
            "date": "2021-01-06T00:00:00",
            "value": 96108.82
        },
        {
            "date": "2021-01-07T00:00:00",
            "value": 99737.16
        },
        {
            "date": "2021-01-08T00:00:00",
            "value": 100580.96
        },
        {
            "date": "2021-01-09T00:00:00",
            "value": 100580.96
        },
        {
            "date": "2021-01-10T00:00:00",
            "value": 100580.96
        },
        {
            "date": "2021-01-11T00:00:00",
            "value": 100623.15
        },
        {
            "date": "2021-01-12T00:00:00",
            "value": 101466.95
        },
        {
            "date": "2021-01-13T00:00:00",
            "value": 101931.04
        },
        {
            "date": "2021-01-14T00:00:00",
            "value": 103787.40
        },
        {
            "date": "2021-01-15T00:00:00",
            "value": 104040.54
        },
        {
            "date": "2021-01-16T00:00:00",
            "value": 104040.54
        },
        {
            "date": "2021-01-17T00:00:00",
            "value": 104040.54
        },
        {
            "date": "2021-01-18T00:00:00",
            "value": 102437.32
        },
        {
            "date": "2021-01-19T00:00:00",
            "value": 104124.92
        },
        {
            "date": "2021-01-20T00:00:00",
            "value": 103196.74
        },
        {
            "date": "2021-01-21T00:00:00",
            "value": 104378.06
        },
        {
            "date": "2021-01-22T00:00:00",
            "value": 103956.16
        },
        {
            "date": "2021-01-23T00:00:00",
            "value": 103956.16
        },
        {
            "date": "2021-01-24T00:00:00",
            "value": 103956.16
        },
        {
            "date": "2021-01-25T00:00:00",
            "value": 104124.92
        },
        {
            "date": "2021-01-26T00:00:00",
            "value": 104124.92
        },
        {
            "date": "2021-01-27T00:00:00",
            "value": 103576.45
        },
        {
            "date": "2021-01-28T00:00:00",
            "value": 102184.18
        },
        {
            "date": "2021-01-29T00:00:00",
            "value": 100032.49
        },
        {
            "date": "2021-01-30T00:00:00",
            "value": 100032.49
        },
        {
            "date": "2021-01-31T00:00:00",
            "value": 100032.49
        },
        {
            "date": "2021-02-01T00:00:00",
            "value": 101509.14
        },
        {
            "date": "2021-02-02T00:00:00",
            "value": 102732.65
        },
        {
            "date": "2021-02-03T00:00:00",
            "value": 104631.20
        },
        {
            "date": "2021-02-04T00:00:00",
            "value": 104546.82
        },
        {
            "date": "2021-02-05T00:00:00",
            "value": 106698.51
        },
        {
            "date": "2021-02-06T00:00:00",
            "value": 106698.51
        },
        {
            "date": "2021-02-07T00:00:00",
            "value": 106698.51
        },
        {
            "date": "2021-02-08T00:00:00",
            "value": 107162.60
        },
        {
            "date": "2021-02-09T00:00:00",
            "value": 105179.67
        },
        {
            "date": "2021-02-10T00:00:00",
            "value": 104799.96
        },
        {
            "date": "2021-02-11T00:00:00",
            "value": 105010.91
        },
        {
            "date": "2021-02-12T00:00:00",
            "value": 104715.58
        },
        {
            "date": "2021-02-13T00:00:00",
            "value": 104715.58
        },
        {
            "date": "2021-02-14T00:00:00",
            "value": 104715.58
        },
        {
            "date": "2021-02-15T00:00:00",
            "value": 106403.18
        },
        {
            "date": "2021-02-16T00:00:00",
            "value": 107457.93
        },
        {
            "date": "2021-02-17T00:00:00",
            "value": 108934.58
        },
        {
            "date": "2021-02-18T00:00:00",
            "value": 112014.45
        },
        {
            "date": "2021-02-19T00:00:00",
            "value": 112267.59
        },
        {
            "date": "2021-02-20T00:00:00",
            "value": 112267.59
        },
        {
            "date": "2021-02-21T00:00:00",
            "value": 112267.59
        },
        {
            "date": "2021-02-22T00:00:00",
            "value": 111803.50
        },
        {
            "date": "2021-02-23T00:00:00",
            "value": 113111.39
        },
        {
            "date": "2021-02-24T00:00:00",
            "value": 112351.97
        },
        {
            "date": "2021-02-25T00:00:00",
            "value": 112942.63
        },
        {
            "date": "2021-02-26T00:00:00",
            "value": 110411.23
        },
        {
            "date": "2021-02-27T00:00:00",
            "value": 110411.23
        },
        {
            "date": "2021-02-28T00:00:00",
            "value": 110411.23
        },
        {
            "date": "2021-03-01T00:00:00",
            "value": 112183.21
        },
        {
            "date": "2021-03-02T00:00:00",
            "value": 113448.91
        },
        {
            "date": "2021-03-03T00:00:00",
            "value": 116275.64
        },
        {
            "date": "2021-03-04T00:00:00",
            "value": 119777.41
        },
        {
            "date": "2021-03-05T00:00:00",
            "value": 121675.96
        },
        {
            "date": "2021-03-06T00:00:00",
            "value": 121675.96
        },
        {
            "date": "2021-03-07T00:00:00",
            "value": 121675.96
        },
        {
            "date": "2021-03-08T00:00:00",
            "value": 121169.68
        },
        {
            "date": "2021-03-09T00:00:00",
            "value": 122772.90
        },
        {
            "date": "2021-03-10T00:00:00",
            "value": 120283.69
        },
        {
            "date": "2021-03-11T00:00:00",
            "value": 119060.18
        },
        {
            "date": "2021-03-12T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-03-13T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-03-14T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-03-15T00:00:00",
            "value": 119819.60
        },
        {
            "date": "2021-03-16T00:00:00",
            "value": 120494.64
        },
        {
            "date": "2021-03-17T00:00:00",
            "value": 119693.03
        },
        {
            "date": "2021-03-18T00:00:00",
            "value": 118722.66
        },
        {
            "date": "2021-03-19T00:00:00",
            "value": 119102.37
        },
        {
            "date": "2021-03-20T00:00:00",
            "value": 119102.37
        },
        {
            "date": "2021-03-21T00:00:00",
            "value": 119102.37
        },
        {
            "date": "2021-03-22T00:00:00",
            "value": 119693.03
        },
        {
            "date": "2021-03-23T00:00:00",
            "value": 118132.00
        },
        {
            "date": "2021-03-24T00:00:00",
            "value": 118132.00
        },
        {
            "date": "2021-03-25T00:00:00",
            "value": 117710.10
        },
        {
            "date": "2021-03-26T00:00:00",
            "value": 118849.23
        },
        {
            "date": "2021-03-27T00:00:00",
            "value": 118849.23
        },
        {
            "date": "2021-03-28T00:00:00",
            "value": 118849.23
        },
        {
            "date": "2021-03-29T00:00:00",
            "value": 118089.81
        },
        {
            "date": "2021-03-30T00:00:00",
            "value": 118553.90
        },
        {
            "date": "2021-03-31T00:00:00",
            "value": 118891.42
        },
        {
            "date": "2021-04-01T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-04-02T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-04-03T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-04-04T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-04-05T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-04-06T00:00:00",
            "value": 119608.65
        },
        {
            "date": "2021-04-07T00:00:00",
            "value": 119988.36
        },
        {
            "date": "2021-04-08T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-04-09T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-04-10T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-04-11T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-04-12T00:00:00",
            "value": 121802.53
        },
        {
            "date": "2021-04-13T00:00:00",
            "value": 121929.10
        },
        {
            "date": "2021-04-14T00:00:00",
            "value": 121886.91
        },
        {
            "date": "2021-04-15T00:00:00",
            "value": 122013.48
        },
        {
            "date": "2021-04-16T00:00:00",
            "value": 121591.58
        },
        {
            "date": "2021-04-17T00:00:00",
            "value": 121591.58
        },
        {
            "date": "2021-04-18T00:00:00",
            "value": 121591.58
        },
        {
            "date": "2021-04-19T00:00:00",
            "value": 122055.67
        },
        {
            "date": "2021-04-20T00:00:00",
            "value": 120916.54
        },
        {
            "date": "2021-04-21T00:00:00",
            "value": 119903.98
        },
        {
            "date": "2021-04-22T00:00:00",
            "value": 120579.02
        },
        {
            "date": "2021-04-23T00:00:00",
            "value": 121085.30
        },
        {
            "date": "2021-04-24T00:00:00",
            "value": 121085.30
        },
        {
            "date": "2021-04-25T00:00:00",
            "value": 121085.30
        },
        {
            "date": "2021-04-26T00:00:00",
            "value": 121043.11
        },
        {
            "date": "2021-04-27T00:00:00",
            "value": 122140.05
        },
        {
            "date": "2021-04-28T00:00:00",
            "value": 122772.90
        },
        {
            "date": "2021-04-29T00:00:00",
            "value": 122097.86
        },
        {
            "date": "2021-04-30T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-05-01T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-05-02T00:00:00",
            "value": 121254.06
        },
        {
            "date": "2021-05-03T00:00:00",
            "value": 122772.90
        },
        {
            "date": "2021-05-04T00:00:00",
            "value": 121633.77
        },
        {
            "date": "2021-05-05T00:00:00",
            "value": 117710.10
        },
        {
            "date": "2021-05-06T00:00:00",
            "value": 116655.35
        },
        {
            "date": "2021-05-07T00:00:00",
            "value": 117077.25
        },
        {
            "date": "2021-05-08T00:00:00",
            "value": 117077.25
        },
        {
            "date": "2021-05-09T00:00:00",
            "value": 117077.25
        },
        {
            "date": "2021-05-10T00:00:00",
            "value": 115516.22
        },
        {
            "date": "2021-05-11T00:00:00",
            "value": 114208.33
        },
        {
            "date": "2021-05-12T00:00:00",
            "value": 113575.48
        },
        {
            "date": "2021-05-13T00:00:00",
            "value": 114545.85
        },
        {
            "date": "2021-05-14T00:00:00",
            "value": 115684.98
        },
        {
            "date": "2021-05-15T00:00:00",
            "value": 115684.98
        },
        {
            "date": "2021-05-16T00:00:00",
            "value": 115684.98
        },
        {
            "date": "2021-05-17T00:00:00",
            "value": 115220.89
        },
        {
            "date": "2021-05-18T00:00:00",
            "value": 116866.30
        },
        {
            "date": "2021-05-19T00:00:00",
            "value": 115220.89
        },
        {
            "date": "2021-05-20T00:00:00",
            "value": 117541.34
        },
        {
            "date": "2021-05-21T00:00:00",
            "value": 118132.00
        },
        {
            "date": "2021-05-22T00:00:00",
            "value": 118132.00
        },
        {
            "date": "2021-05-23T00:00:00",
            "value": 118132.00
        },
        {
            "date": "2021-05-24T00:00:00",
            "value": 118807.04
        },
        {
            "date": "2021-05-25T00:00:00",
            "value": 120030.55
        },
        {
            "date": "2021-05-26T00:00:00",
            "value": 120241.50
        },
        {
            "date": "2021-05-27T00:00:00",
            "value": 120410.26
        },
        {
            "date": "2021-05-28T00:00:00",
            "value": 121760.34
        },
        {
            "date": "2021-05-29T00:00:00",
            "value": 121760.34
        },
        {
            "date": "2021-05-30T00:00:00",
            "value": 121760.34
        },
        {
            "date": "2021-05-31T00:00:00",
            "value": 121127.49
        },
        {
            "date": "2021-06-01T00:00:00",
            "value": 119439.89
        },
        {
            "date": "2021-06-02T00:00:00",
            "value": 119608.65
        },
        {
            "date": "2021-06-03T00:00:00",
            "value": 121380.63
        },
        {
            "date": "2021-06-04T00:00:00",
            "value": 123194.80
        },
        {
            "date": "2021-06-05T00:00:00",
            "value": 123194.80
        },
        {
            "date": "2021-06-06T00:00:00",
            "value": 123194.80
        },
        {
            "date": "2021-06-07T00:00:00",
            "value": 121591.58
        },
        {
            "date": "2021-06-08T00:00:00",
            "value": 121338.44
        },
        {
            "date": "2021-06-09T00:00:00",
            "value": 121211.87
        },
        {
            "date": "2021-06-10T00:00:00",
            "value": 121043.11
        },
        {
            "date": "2021-06-11T00:00:00",
            "value": 119186.75
        },
        {
            "date": "2021-06-12T00:00:00",
            "value": 119186.75
        },
        {
            "date": "2021-06-13T00:00:00",
            "value": 119186.75
        },
        {
            "date": "2021-06-14T00:00:00",
            "value": 119186.75
        },
        {
            "date": "2021-06-15T00:00:00",
            "value": 120916.54
        },
        {
            "date": "2021-06-16T00:00:00",
            "value": 122013.48
        },
        {
            "date": "2021-06-17T00:00:00",
            "value": 123321.37
        },
        {
            "date": "2021-06-18T00:00:00",
            "value": 122266.62
        },
        {
            "date": "2021-06-19T00:00:00",
            "value": 122266.62
        },
        {
            "date": "2021-06-20T00:00:00",
            "value": 122266.62
        },
        {
            "date": "2021-06-21T00:00:00",
            "value": 118469.52
        },
        {
            "date": "2021-06-22T00:00:00",
            "value": 121000.92
        },
        {
            "date": "2021-06-23T00:00:00",
            "value": 119271.13
        },
        {
            "date": "2021-06-24T00:00:00",
            "value": 118300.76
        },
        {
            "date": "2021-06-25T00:00:00",
            "value": 119313.32
        },
        {
            "date": "2021-06-26T00:00:00",
            "value": 119313.32
        },
        {
            "date": "2021-06-27T00:00:00",
            "value": 119313.32
        },
        {
            "date": "2021-06-28T00:00:00",
            "value": 118933.61
        },
        {
            "date": "2021-06-29T00:00:00",
            "value": 119144.56
        },
        {
            "date": "2021-06-30T00:00:00",
            "value": 1434338.88
        },
        {
            "date": "2021-07-01T00:00:00",
            "value": 1433074.43
        },
        {
            "date": "2021-07-02T00:00:00",
            "value": 1435017.89
        },
        {
            "date": "2021-07-03T00:00:00",
            "value": 1435017.89
        },
        {
            "date": "2021-07-04T00:00:00",
            "value": 1435017.89
        },
        {
            "date": "2021-07-05T00:00:00",
            "value": 1434647.48
        },
        {
            "date": "2021-07-06T00:00:00",
            "value": 1432882.77
        },
        {
            "date": "2021-07-07T00:00:00",
            "value": 1439963.81
        },
        {
            "date": "2021-07-08T00:00:00",
            "value": 1437177.33
        },
        {
            "date": "2021-07-09T00:00:00",
            "value": 1425785.85
        },
        {
            "date": "2021-07-10T00:00:00",
            "value": 1425785.85
        },
        {
            "date": "2021-07-11T00:00:00",
            "value": 1425785.85
        },
        {
            "date": "2021-07-12T00:00:00",
            "value": 1428108.23
        },
        {
            "date": "2021-07-13T00:00:00",
            "value": 1429558.45
        },
        {
            "date": "2021-07-14T00:00:00",
            "value": 1428247.91
        },
        {
            "date": "2021-07-15T00:00:00",
            "value": 1419192.55
        },
        {
            "date": "2021-07-16T00:00:00",
            "value": 1416197.02
        },
        {
            "date": "2021-07-17T00:00:00",
            "value": 1416197.02
        },
        {
            "date": "2021-07-18T00:00:00",
            "value": 1416197.02
        },
        {
            "date": "2021-07-19T00:00:00",
            "value": 1404566.53
        },
        {
            "date": "2021-07-20T00:00:00",
            "value": 1399443.96
        },
        {
            "date": "2021-07-21T00:00:00",
            "value": 1411029.91
        },
        {
            "date": "2021-07-22T00:00:00",
            "value": 1424452.32
        },
        {
            "date": "2021-07-23T00:00:00",
            "value": 1419304.65
        },
        {
            "date": "2021-07-24T00:00:00",
            "value": 1419304.65
        },
        {
            "date": "2021-07-25T00:00:00",
            "value": 1419304.65
        },
        {
            "date": "2021-07-26T00:00:00",
            "value": 1419865.73
        },
        {
            "date": "2021-07-27T00:00:00",
            "value": 1428992.87
        },
        {
            "date": "2021-07-28T00:00:00",
            "value": 1421131.43
        },
        {
            "date": "2021-07-29T00:00:00",
            "value": 1433851.54
        },
        {
            "date": "2021-07-30T00:00:00",
            "value": 1430605.15
        },
        {
            "date": "2021-07-31T00:00:00",
            "value": 1430605.15
        },
        {
            "date": "2021-08-01T00:00:00",
            "value": 1430605.15
        },
        {
            "date": "2021-08-02T00:00:00",
            "value": 1445435.15
        },
        {
            "date": "2021-08-03T00:00:00",
            "value": 1449623.28
        },
        {
            "date": "2021-08-04T00:00:00",
            "value": 1453364.36
        },
        {
            "date": "2021-08-05T00:00:00",
            "value": 1451890.20
        },
        {
            "date": "2021-08-06T00:00:00",
            "value": 1465089.02
        },
        {
            "date": "2021-08-07T00:00:00",
            "value": 1465089.02
        },
        {
            "date": "2021-08-08T00:00:00",
            "value": 1465089.02
        },
        {
            "date": "2021-08-09T00:00:00",
            "value": 1476495.41
        },
        {
            "date": "2021-08-10T00:00:00",
            "value": 1481068.14
        },
        {
            "date": "2021-08-11T00:00:00",
            "value": 1491750.13
        },
        {
            "date": "2021-08-12T00:00:00",
            "value": 1495318.67
        },
        {
            "date": "2021-08-13T00:00:00",
            "value": 1496534.87
        },
        {
            "date": "2021-08-14T00:00:00",
            "value": 1496534.87
        },
        {
            "date": "2021-08-15T00:00:00",
            "value": 1496534.87
        },
        {
            "date": "2021-08-16T00:00:00",
            "value": 1483707.75
        },
        {
            "date": "2021-08-17T00:00:00",
            "value": 1468444.24
        },
        {
            "date": "2021-08-18T00:00:00",
            "value": 1467612.04
        },
        {
            "date": "2021-08-19T00:00:00",
            "value": 1458971.13
        },
        {
            "date": "2021-08-20T00:00:00",
            "value": 1459120.58
        },
        {
            "date": "2021-08-21T00:00:00",
            "value": 1459120.58
        },
        {
            "date": "2021-08-22T00:00:00",
            "value": 1459120.58
        },
        {
            "date": "2021-08-23T00:00:00",
            "value": 1460599.57
        },
        {
            "date": "2021-08-24T00:00:00",
            "value": 1465648.77
        },
        {
            "date": "2021-08-25T00:00:00",
            "value": 1468895.07
        },
        {
            "date": "2021-08-26T00:00:00",
            "value": 1461012.90
        },
        {
            "date": "2021-08-27T00:00:00",
            "value": 1459643.64
        },
        {
            "date": "2021-08-28T00:00:00",
            "value": 1459643.64
        },
        {
            "date": "2021-08-29T00:00:00",
            "value": 1459643.64
        },
        {
            "date": "2021-08-30T00:00:00",
            "value": 1464146.93
        },
        {
            "date": "2021-08-31T00:00:00",
            "value": 1461635.88
        },
        {
            "date": "2021-09-01T00:00:00",
            "value": 1461645.38
        },
        {
            "date": "2021-09-02T00:00:00",
            "value": 1462005.18
        },
        {
            "date": "2021-09-03T00:00:00",
            "value": 1460415.32
        },
        {
            "date": "2021-09-04T00:00:00",
            "value": 1460415.32
        },
        {
            "date": "2021-09-05T00:00:00",
            "value": 1460415.32
        },
        {
            "date": "2021-09-06T00:00:00",
            "value": 1462851.97
        },
        {
            "date": "2021-09-07T00:00:00",
            "value": 1471825.50
        },
        {
            "date": "2021-09-08T00:00:00",
            "value": 1460424.26
        },
        {
            "date": "2021-09-09T00:00:00",
            "value": 1446122.71
        },
        {
            "date": "2021-09-10T00:00:00",
            "value": 1444629.20
        },
        {
            "date": "2021-09-11T00:00:00",
            "value": 1444629.20
        },
        {
            "date": "2021-09-12T00:00:00",
            "value": 1444629.20
        },
        {
            "date": "2021-09-13T00:00:00",
            "value": 1441622.95
        },
        {
            "date": "2021-09-14T00:00:00",
            "value": 1443651.71
        },
        {
            "date": "2021-09-15T00:00:00",
            "value": 1438119.93
        },
        {
            "date": "2021-09-16T00:00:00",
            "value": 1445356.81
        },
        {
            "date": "2021-09-17T00:00:00",
            "value": 1437867.67
        },
        {
            "date": "2021-09-18T00:00:00",
            "value": 1437867.67
        },
        {
            "date": "2021-09-19T00:00:00",
            "value": 1437867.67
        },
        {
            "date": "2021-09-20T00:00:00",
            "value": 1421093.00
        },
        {
            "date": "2021-09-21T00:00:00",
            "value": 1413815.60
        },
        {
            "date": "2021-09-22T00:00:00",
            "value": 1417102.30
        },
        {
            "date": "2021-09-23T00:00:00",
            "value": 1427838.41
        },
        {
            "date": "2021-09-24T00:00:00",
            "value": 1425642.01
        },
        {
            "date": "2021-09-25T00:00:00",
            "value": 1425642.01
        },
        {
            "date": "2021-09-26T00:00:00",
            "value": 1425642.01
        },
        {
            "date": "2021-09-27T00:00:00",
            "value": 1428907.56
        },
        {
            "date": "2021-09-28T00:00:00",
            "value": 1418579.99
        },
        {
            "date": "2021-09-29T00:00:00",
            "value": 1410007.05
        },
        {
            "date": "2021-09-30T00:00:00",
            "value": 1426800.52
        },
        {
            "date": "2021-10-01T00:00:00",
            "value": 2408777.64
        },
        {
            "date": "2021-10-02T00:00:00",
            "value": 2400827.64
        },
        {
            "date": "2021-10-03T00:00:00",
            "value": 2400827.64
        },
        {
            "date": "2021-10-04T00:00:00",
            "value": 2422870.98
        },
        {
            "date": "2021-10-05T00:00:00",
            "value": 2413897.87
        },
        {
            "date": "2021-10-06T00:00:00",
            "value": 2408075.44
        },
        {
            "date": "2021-10-07T00:00:00",
            "value": 2418195.28
        },
        {
            "date": "2021-10-08T00:00:00",
            "value": 2424302.46
        },
        {
            "date": "2021-10-09T00:00:00",
            "value": 2424302.46
        },
        {
            "date": "2021-10-10T00:00:00",
            "value": 2424302.46
        },
        {
            "date": "2021-10-11T00:00:00",
            "value": 2423550.27
        },
        {
            "date": "2021-10-12T00:00:00",
            "value": 2419508.13
        },
        {
            "date": "2021-10-13T00:00:00",
            "value": 2416799.75
        },
        {
            "date": "2021-10-14T00:00:00",
            "value": 2418164.58
        },
        {
            "date": "2021-10-15T00:00:00",
            "value": 2423257.01
        },
        {
            "date": "2021-10-16T00:00:00",
            "value": 2423257.01
        },
        {
            "date": "2021-10-17T00:00:00",
            "value": 2423257.01
        },
        {
            "date": "2021-10-18T00:00:00",
            "value": 2428066.90
        },
        {
            "date": "2021-10-19T00:00:00",
            "value": 2426021.05
        },
        {
            "date": "2021-10-20T00:00:00",
            "value": 2434764.59
        },
        {
            "date": "2021-10-21T00:00:00",
            "value": 2434461.05
        },
        {
            "date": "2021-10-22T00:00:00",
            "value": 2433253.80
        },
        {
            "date": "2021-10-23T00:00:00",
            "value": 2433253.80
        },
        {
            "date": "2021-10-24T00:00:00",
            "value": 2433253.80
        },
        {
            "date": "2021-10-25T00:00:00",
            "value": 2439914.40
        },
        {
            "date": "2021-10-26T00:00:00",
            "value": 2449654.20
        },
        {
            "date": "2021-10-27T00:00:00",
            "value": 2442109.14
        },
        {
            "date": "2021-10-28T00:00:00",
            "value": 2440267.48
        },
        {
            "date": "2021-10-29T00:00:00",
            "value": 2435982.25
        },
        {
            "date": "2021-10-30T00:00:00",
            "value": 2435982.25
        },
        {
            "date": "2021-10-31T00:00:00",
            "value": 2435982.25
        },
        {
            "date": "2021-11-01T00:00:00",
            "value": 2433601.47
        },
        {
            "date": "2021-11-02T00:00:00",
            "value": 2429854.61
        },
        {
            "date": "2021-11-03T00:00:00",
            "value": 2439123.97
        },
        {
            "date": "2021-11-04T00:00:00",
            "value": 2448621.15
        },
        {
            "date": "2021-11-05T00:00:00",
            "value": 2445501.79
        },
        {
            "date": "2021-11-06T00:00:00",
            "value": 2445501.79
        },
        {
            "date": "2021-11-07T00:00:00",
            "value": 2445501.79
        },
        {
            "date": "2021-11-08T00:00:00",
            "value": 2438550.27
        },
        {
            "date": "2021-11-09T00:00:00",
            "value": 2435013.07
        },
        {
            "date": "2021-11-10T00:00:00",
            "value": 2432288.91
        },
        {
            "date": "2021-11-11T00:00:00",
            "value": 2428651.71
        },
        {
            "date": "2021-11-12T00:00:00",
            "value": 2436343.19
        },
        {
            "date": "2021-11-13T00:00:00",
            "value": 2436343.19
        },
        {
            "date": "2021-11-14T00:00:00",
            "value": 2436343.19
        },
        {
            "date": "2021-11-15T00:00:00",
            "value": 2438390.03
        },
        {
            "date": "2021-11-16T00:00:00",
            "value": 2432859.75
        },
        {
            "date": "2021-11-17T00:00:00",
            "value": 2411535.39
        },
        {
            "date": "2021-11-18T00:00:00",
            "value": 2407069.94
        },
        {
            "date": "2021-11-19T00:00:00",
            "value": 2404984.43
        },
        {
            "date": "2021-11-20T00:00:00",
            "value": 2404984.43
        },
        {
            "date": "2021-11-21T00:00:00",
            "value": 2404984.43
        },
        {
            "date": "2021-11-22T00:00:00",
            "value": 2394691.13
        },
        {
            "date": "2021-11-23T00:00:00",
            "value": 2396711.11
        },
        {
            "date": "2021-11-24T00:00:00",
            "value": 2397058.43
        },
        {
            "date": "2021-11-25T00:00:00",
            "value": 2395087.88
        },
        {
            "date": "2021-11-26T00:00:00",
            "value": 2384582.61
        },
        {
            "date": "2021-11-27T00:00:00",
            "value": 2384582.61
        },
        {
            "date": "2021-11-28T00:00:00",
            "value": 2384582.61
        },
        {
            "date": "2021-11-29T00:00:00",
            "value": 2378891.84
        },
        {
            "date": "2021-11-30T00:00:00",
            "value": 2384552.41
        },
        {
            "date": "2021-12-01T00:00:00",
            "value": 2377568.48
        },
        {
            "date": "2021-12-02T00:00:00",
            "value": 2377999.14
        },
        {
            "date": "2021-12-03T00:00:00",
            "value": 2383074.92
        },
        {
            "date": "2021-12-04T00:00:00",
            "value": 2383074.92
        },
        {
            "date": "2021-12-05T00:00:00",
            "value": 2383074.92
        },
        {
            "date": "2021-12-06T00:00:00",
            "value": 2376219.95
        },
        {
            "date": "2021-12-07T00:00:00",
            "value": 2387068.75
        },
        {
            "date": "2021-12-08T00:00:00",
            "value": 2396569.13
        },
        {
            "date": "2021-12-09T00:00:00",
            "value": 2392497.92
        },
        {
            "date": "2021-12-10T00:00:00",
            "value": 2389321.38
        },
        {
            "date": "2021-12-11T00:00:00",
            "value": 2389321.38
        },
        {
            "date": "2021-12-12T00:00:00",
            "value": 2389321.38
        },
        {
            "date": "2021-12-13T00:00:00",
            "value": 2391834.45
        },
        {
            "date": "2021-12-14T00:00:00",
            "value": 2392341.15
        },
        {
            "date": "2021-12-15T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-16T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-17T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-18T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-19T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-20T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-21T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-22T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-23T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-24T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-25T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-26T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-27T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-28T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-29T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-30T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2021-12-31T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-01T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-02T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-03T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-04T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-05T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-06T00:00:00",
            "value": 2382771.99
        },
        {
            "date": "2022-01-07T00:00:00",
            "value": 2393143.02
        },
        {
            "date": "2022-01-08T00:00:00",
            "value": 2393143.02
        },
        {
            "date": "2022-01-09T00:00:00",
            "value": 2393143.02
        },
        {
            "date": "2022-01-10T00:00:00",
            "value": 2399154.85
        },
        {
            "date": "2022-01-11T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-12T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-13T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-14T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-15T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-16T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-17T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-18T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-19T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-20T00:00:00",
            "value": 2392229.61
        },
        {
            "date": "2022-01-21T00:00:00",
            "value": 2380766.32
        },
        {
            "date": "2022-01-22T00:00:00",
            "value": 2380766.32
        },
        {
            "date": "2022-01-23T00:00:00",
            "value": 2380766.32
        },
        {
            "date": "2022-01-24T00:00:00",
            "value": 2370752.47
        },
        {
            "date": "2022-01-25T00:00:00",
            "value": 2355133.65
        },
        {
            "date": "2022-01-26T00:00:00",
            "value": 2355133.65
        },
        {
            "date": "2022-01-27T00:00:00",
            "value": 2356179.09
        },
        {
            "date": "2022-01-28T00:00:00",
            "value": 2365007.45
        },
        {
            "date": "2022-01-29T00:00:00",
            "value": 2365007.45
        },
        {
            "date": "2022-01-30T00:00:00",
            "value": 2365007.45
        },
        {
            "date": "2022-01-31T00:00:00",
            "value": 2353289.71
        },
        {
            "date": "2022-02-01T00:00:00",
            "value": 2352096.88
        },
        {
            "date": "2022-02-02T00:00:00",
            "value": 2365008.68
        },
        {
            "date": "2022-02-03T00:00:00",
            "value": 2365199.44
        },
        {
            "date": "2022-02-04T00:00:00",
            "value": 2368294.98
        },
        {
            "date": "2022-02-05T00:00:00",
            "value": 2368294.98
        },
        {
            "date": "2022-02-06T00:00:00",
            "value": 2368294.98
        },
        {
            "date": "2022-02-07T00:00:00",
            "value": 2367224.55
        },
        {
            "date": "2022-02-08T00:00:00",
            "value": 2372424.53
        },
        {
            "date": "2022-02-09T00:00:00",
            "value": 2384511.84
        },
        {
            "date": "2022-02-10T00:00:00",
            "value": 2388567.26
        },
        {
            "date": "2022-02-11T00:00:00",
            "value": 2383927.93
        },
        {
            "date": "2022-02-12T00:00:00",
            "value": 2383927.93
        },
        {
            "date": "2022-02-13T00:00:00",
            "value": 2383927.93
        },
        {
            "date": "2022-02-14T00:00:00",
            "value": 2383216.88
        },
        {
            "date": "2022-02-15T00:00:00",
            "value": 2376735.45
        },
        {
            "date": "2022-02-16T00:00:00",
            "value": 2376482.38
        },
        {
            "date": "2022-02-17T00:00:00",
            "value": 2379940.12
        },
        {
            "date": "2022-02-18T00:00:00",
            "value": 2380171.48
        },
        {
            "date": "2022-02-19T00:00:00",
            "value": 2380171.48
        },
        {
            "date": "2022-02-20T00:00:00",
            "value": 2380171.48
        },
        {
            "date": "2022-02-21T00:00:00",
            "value": 2380325.96
        },
        {
            "date": "2022-02-22T00:00:00",
            "value": 2371090.07
        },
        {
            "date": "2022-02-23T00:00:00",
            "value": 2371280.33
        },
        {
            "date": "2022-02-24T00:00:00",
            "value": 2349017.36
        },
        {
            "date": "2022-02-25T00:00:00",
            "value": 2343048.00
        },
        {
            "date": "2022-02-26T00:00:00",
            "value": 2343048.00
        },
        {
            "date": "2022-02-27T00:00:00",
            "value": 2343048.00
        },
        {
            "date": "2022-02-28T00:00:00",
            "value": 2345568.42
        },
        {
            "date": "2022-03-01T00:00:00",
            "value": 2374161.87
        },
        {
            "date": "2022-03-02T00:00:00",
            "value": 2394543.77
        },
        {
            "date": "2022-03-03T00:00:00",
            "value": 2399693.21
        },
        {
            "date": "2022-03-04T00:00:00",
            "value": 2395628.67
        },
        {
            "date": "2022-03-05T00:00:00",
            "value": 2395628.67
        },
        {
            "date": "2022-03-06T00:00:00",
            "value": 2395628.67
        },
        {
            "date": "2022-03-07T00:00:00",
            "value": 2393508.92
        },
        {
            "date": "2022-03-08T00:00:00",
            "value": 2813163.62
        },
        {
            "date": "2022-03-09T00:00:00",
            "value": 2818325.97
        },
        {
            "date": "2022-03-10T00:00:00",
            "value": 2827562.50
        },
        {
            "date": "2022-03-11T00:00:00",
            "value": 2827449.58
        },
        {
            "date": "2022-03-12T00:00:00",
            "value": 2827449.58
        },
        {
            "date": "2022-03-13T00:00:00",
            "value": 2827449.58
        },
        {
            "date": "2022-03-14T00:00:00",
            "value": 2831607.87
        },
        {
            "date": "2022-03-15T00:00:00",
            "value": 2830134.50
        },
        {
            "date": "2022-03-16T00:00:00",
            "value": 2838570.90
        },
        {
            "date": "2022-03-17T00:00:00",
            "value": 2850614.98
        },
        {
            "date": "2022-03-18T00:00:00",
            "value": 2854852.98
        },
        {
            "date": "2022-03-19T00:00:00",
            "value": 2854852.98
        },
        {
            "date": "2022-03-20T00:00:00",
            "value": 2854852.98
        },
        {
            "date": "2022-03-21T00:00:00",
            "value": 2859631.61
        },
        {
            "date": "2022-03-22T00:00:00",
            "value": 2863249.70
        },
        {
            "date": "2022-03-23T00:00:00",
            "value": 2865818.95
        },
        {
            "date": "2022-03-24T00:00:00",
            "value": 2868777.05
        },
        {
            "date": "2022-03-25T00:00:00",
            "value": 2863715.34
        },
        {
            "date": "2022-03-26T00:00:00",
            "value": 2863715.34
        },
        {
            "date": "2022-03-27T00:00:00",
            "value": 2863715.34
        },
        {
            "date": "2022-03-28T00:00:00",
            "value": 2863715.34
        },
        {
            "date": "2022-03-29T00:00:00",
            "value": 2863715.34
        }
    ],
    "accounts": [
        {
            "accountKey": "fa_bde96750bcc64d9982a564c85f14166b",
            "portfolioKeys": [
                "prt_01f2ffbebb174e7b961f10a9ab6107b2"
            ],
            "name": "Bullseye Test1 CMA",
            "number": "TEST123456",
            "type": "DepositCma",
            "institution": "Macquarie Bank",
            "bsbNumber": "999999",
            "status": "Active"
        },
        {
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "portfolioKeys": [
                "prt_01f2ffbebb174e7b961f10a9ab6107b2"
            ],
            "name": "Bullseye Test1 ASX",
            "number": "BullEye1_ASX",
            "type": "SecurityAsx",
            "institution": "OpenMarkets",
            "status": "Active"
        },
        {
            "accountKey": "fa_33ae74e281b34815aae6b1465595c2b4",
            "portfolioKeys": [
                "prt_01f2ffbebb174e7b961f10a9ab6107b2"
            ],
            "name": "Bullseye Test1 Unlisted",
            "number": "BullseyeTest1Unlisted",
            "type": "UnlistedAssets",
            "institution": "Unlisted Securities",
            "status": "Active"
        },
        {
            "accountKey": "fa_5511100aaebb4778960efb2d1be4468a",
            "portfolioKeys": [
                "prt_01f2ffbebb174e7b961f10a9ab6107b2"
            ],
            "name": "External Account",
            "number": "12121212",
            "type": "DepositCma",
            "institution": "Bank of Queensland",
            "bsbNumber": "182-888",
            "status": "Active"
        }
    ]
};
